export const CDN = 'https://resources.getcartwheel.com/share/demo-videos/';
